import React from 'react';
import AIinClassrooms2025  from 'views/AIinClassrooms2025';

const ExtraCurricularActivitiesPage = () => {
  return <AIinClassrooms2025 />;
};

export default ExtraCurricularActivitiesPage;